import { convertClustersToFlatFeaturesMap } from './convertClustersToFlatFeaturesMap';
import { convertClustersToMultipinFeaturesMap } from './convertClustersToMultipinFeaturesMap';
import { convertFrecklesToFeaturesMap } from './convertFrecklesToFeaturesMap';
import { IMapMappedResponse } from '../../../Map/types/mappedResponse';
import { IPublicWebV1MapResponse } from '../../repositories/dailyrent/entities/response/PublicWebV1MapResponse';

interface ICreateMapResponse200Options {
  /** Эксперимент мультипинов: кластер не раскрывается в «ромашку», а становится одним пином с каунтером */
  isMultipinsEnabled: boolean;
}

// Единственная развилка эксперимента мультипинов: дальше по цепочке (сетка, слои,
// клик, превью) фичи обеих веток обрабатываются одинаково, различаются только данные.
export const createMapResponse200 =
  ({ isMultipinsEnabled }: ICreateMapResponse200Options) =>
  (response: IPublicWebV1MapResponse): IMapMappedResponse => ({
    ...response,
    clusters: isMultipinsEnabled
      ? convertClustersToMultipinFeaturesMap(response.clusters)
      : convertClustersToFlatFeaturesMap(response.clusters),
    freckles: convertFrecklesToFeaturesMap(response.freckles),
  });
